
export enum ESortRule {
  None = '',
  /**
   * 降序
   */
  Desc = '0',
  /**
   * 升序
   */
  Asc = '1',
}



// WEBPACK FOOTER //
// ./src/enums/ESortRule.ts